import React from 'react';

import { getIsEmoji } from 'widget/actions';
import { Markdown } from 'widget/components';
import { useIsMutedDark } from 'widget/hooks';

interface MsgText {
  children: string;
}

const MsgText = ({ children }: MsgText) => {
  const isMutedDark = useIsMutedDark();

  const isEmoji = getIsEmoji(children);
  const color = isMutedDark ? 'white' : 'gray-850';

  return (
    <Markdown color={color} size={isEmoji ? 40 : 14}>
      {children}
    </Markdown>
  );
};

export default MsgText;
